// extracted by extract-css-chunks-webpack-plugin
module.exports = {"ourTakeWrapper":"_3vdm7x","banner":"qtjwRn"};